import Head from "next/head";
import AppContainer from "../../components/AppContainer";
import Footer from "../../components/Footer/Footer";
import { localLegalInfo } from "../../components/utils/local.policy";
import { getStore } from "../../services/backend/serverSideProps";

export async function getServerSideProps(context) {
  return getStore(context);
}

const Contact = (props) => {
  const { storeData } = props;

  let contacts =
    storeData?.legalInfo && storeData?.legalInfo?.contacts
      ? storeData.legalInfo.contacts
      : localLegalInfo?.contacts || "";

  console.log(contacts);
  contacts = contacts.replace("{{store email}}", storeData?.email || "NA");
  contacts = contacts.replace("{{store phone}}", "").replace("Phone", "");
  contacts = contacts.replaceAll("{{store instagram}}", storeData?.instagramHandle || "NA");

  return (
    <AppContainer>
      <Head>
        <meta name="robots" content="noindex, nofollow, noarchive, nosnippet" />
        <title>Contact Us</title>
      </Head>
      <main>
        <h2 className="sidepage-title">Contact Us</h2>

        {/* content */}
        {contacts.trim() !== "" ? (
          <div className="sidepage-content" dangerouslySetInnerHTML={{ __html: contacts }} />
        ) : null}
      </main>

      <Footer />
    </AppContainer>
  );
};

export default Contact;
